// extracted by mini-css-extract-plugin
export default {"voice-metadata":"VoiceMetadata_voice-metadata__4vu1p"};